import axios from 'axios';

export async function tryFetch(url, options) {
  let response = null;
  let parsed = null;
  let error = null;

  const _options = {
    headers: {
      'Content-Type': 'application/json'
    },
    ...options
  };

  try {
    response = await fetch(url, _options);
    parsed = await response.json();

    if (!response.ok) {
      throw new Error('Cannot retrieve data');
    }
  } catch (err) {
    error = err;
  }

  return [parsed, error];
}

export function getRecaptchaSiteKey () {
  return Promise.resolve('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI');
}

export async function getFormValidators () {
    let formValidators = null;
    const url = `${CMS.contextPath}/.rest/nodes/v1/config/modules/form/config/validators?depth=3&includeMetadata=false`;

    try {
        formValidators = await axios.get(url);
        formValidators = formValidators.data;
    } catch (error) {
        formValidators = formValidators ? formValidators : null;
        console.error(error);
    }

    return formValidators;
}

export const getAssetLink = (asset, rendition = 'small') => {
  if (typeof asset === 'string') {
    return `${CMS.contextPath}/dam/${asset}`;
  }

  if (typeof asset === 'object') {
    return asset?.renditions?.[rendition || '']?.link || asset?.['@link'] || '';
  }

  return '';
};
